export default __webpack_public_path__ + "d4b725cb4e74f7d858a8a70ec9d83c41.png";